import { SxProps } from '@mui/material'
import Button from '@mui/material/Button'

type Props = {
  children: React.ReactNode
  disabled?: boolean
  fullWidth?: boolean
  href?: string
  loading?: boolean
  onClick?: () => void
  size?: 'small' | 'medium' | 'large'
  sx?: SxProps
  variant?: 'text' | 'outlined' | 'contained'
}

const RoundButton: React.FC<Props> = (props) => {
  const { children, disabled, fullWidth, loading, sx, variant, ...rest } = props
  return (
    <Button
      disabled={disabled || loading}
      fullWidth={fullWidth}
      sx={{
        backgroundColor: variant === 'outlined' ? '#FFFFFF' : undefined,
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: '100vh',
        color: variant === 'outlined' ? 'primary.main' : undefined,
        lineHeight: '2.2',
        ...sx,
      }}
      variant="contained"
      {...rest}
    >
      {children}
    </Button>
  )
}

export default RoundButton
